import { render } from "./professorCadastrar.vue?vue&type=template&id=7b830fa8"
import script from "./professorCadastrar.vue?vue&type=script&lang=js"
export * from "./professorCadastrar.vue?vue&type=script&lang=js"

import "./professorCadastrar.vue?vue&type=style&index=0&id=7b830fa8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__